<template>
    <a-modal
        style="top : 15px"
        :zIndex="99999"
        :width="700"
        title="Adicionar nova opção"
        :visible="active"
        @cancel="active = false"
    >   

    <template slot="footer">
        <div class="flex w-full justify-end">
            <a-button :loading="loading" @click="active = false"> Cancelar </a-button>
            <a-button type="danger" :loading="loading" @click="save()" > Salvar </a-button>
        </div>
    </template>

    <ValidationObserver ref="frm">
        <div class="vx-row ml-2 mr-2">
            <div class="w-full border border-dashed border-l-2 border-r-2 border-t-2 border-b-2 border-grey-light pl-8 pt-4 pr-2 pb-4 mb-6 rounded list-item" style="position: relative">
                <div class="vx-row">
                    <div class="vx-row w-full">
                        <div class="vx-col w-5/12">
                            <ValidationProvider v-slot="{ errors }" rules="required" name="Descrição">
                                <span> Descrição </span>
                                <vs-input 
                                    class="vx-col w-full" 
                                    v-model="optionsData.description" />
                                <span class="text-danger">{{ errors[0] }}</span>   
                            </ValidationProvider>
                        </div>

                        <div class="vx-col w-3/12">
                            <span> Identificador </span>
                            <vs-input 
                                class="vx-col w-full" 
                                v-model="optionsData.alias" />
                        </div>

                        <div class="vx-col w-2/12">
                            <span> Mínimo </span>
                            <a-input-number
                                class="w-full h-12" 
                                name="optionMin" 
                                size="large" 
                                v-model="optionsData.min" 
                                :min="0" 
                                :max="optionsData.max || 0" 
                                @change="(value) => !value ? optionsData.min = 0 : optionsData.min = value" />
                        </div>

                        <div class="vx-col w-2/12">
                            <span> Máximo </span>
                            <a-input-number
                                class="w-full h-12" 
                                name="optionMin" 
                                size="large" 
                                v-model="optionsData.max" 
                                :min="1" 
                                @change="(value) => !value ? optionsData.max = 0 : optionsData.max = value" />
                        </div>
                    </div>
                </div>

                <vs-divider class="w-full pr-8" position="center" icon-pack="feather" icon="icon-arrow-down-circle" color="primary" border-style="dashed"> Itens </vs-divider>

                    <draggable :list="optionsData.items" class="cursor-move w-full pr-8">
                        <div class="w-full bg-grey-light-super border border-dashed border-grey-light pl-4 pt-4 pb-4 mb-6 rounded list-item" v-for="(item, iItem) in optionsData.items" :key="iItem + 0" style="position: relative">
                            
                            <vs-button size="small" radius class="btn-remove-product-option" color="danger" type="gradient" icon-pack="feather" icon="icon-trash" @click="removeItemOption(item.id)"></vs-button>

                            <div class="vx-row w-full">
                                <div class="w-1/12">
                                    <vs-checkbox class="ml-4 mt-8" color="danger" v-model="item.active"></vs-checkbox>
                                </div>

                                <div class="vx-col w-4/12">
                                    <ValidationProvider v-slot="{ errors }" rules="required" name="Descrição">
                                        <span> Descrição </span>
                                        <vs-input
                                            :name="item.id"
                                            v-validate="{ required : true }"
                                            data-vv-as="Descrição"
                                            class="vx-col w-full" 
                                            v-model="item.description" />
                                        <span class="text-danger">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>

                                <div class="vx-col w-2/12">
                                    <span> Mín.: </span>
                                    <a-input-number
                                        class="w-full h-12" 
                                        name="itemMin" 
                                        size="large" 
                                        v-model="item.min" 
                                        :min="0" 
                                        :max="item.max || 0" 
                                        @change="(value) => !value ? item.min = 0 : item.min = value" />
                                </div>

                                <div class="vx-col w-2/12">
                                    <span> Máx.: </span>
                                    <a-input-number
                                        class="w-full h-12" 
                                        name="itemMax" 
                                        size="large" 
                                        v-model="item.max" 
                                        :min="0"
                                        :max="optionsData.max" 
                                        @change="(value) => !value ? item.max = 0 : item.max = value" />
                                </div>

                                <div class="vx-col w-3/12">
                                    <span> Preço </span>
                                    <money 
                                        class="vs-inputx vs-input--input normal"
                                        style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                        v-model="item.value" 
                                        v-bind="{
                                            decimal: ',',
                                            thousands: '.',
                                            prefix: 'R$ ',
                                            precision: 2,
                                            masked: false
                                        }">
                                    </money>
                                </div>
                            </div>
                        </div>
                    </draggable>
                
                <vs-button 
                    class="mt-6 w-full" 
                    color="primary" 
                    type="flat" 
                    icon-pack="feather" 
                    icon="icon-plus-circle" @click="addMoreItemsOption()"> Adicionar mais </vs-button>

            </div>
        </div>
        </ValidationObserver>
    </a-modal>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import _misc from '@/assets/utils/misc'
    import draggable from 'vuedraggable'
    import { propagate } from './Options'

    const ref = firebase.firestore()

    export default {
        props : {
            visible : {
                type : Boolean,
                required : true
            },
            data : {
                type : Object,
                required : false
            }
        },

        components : {
            draggable
        },

        data () {
            return {
                active : false,
                loading : false,
                optionsData : {},
                companyId : this.$store.getters.getCompanyID
            }
        },

        mounted () {
            this.active = this.visible
        },

        watch : {
            visible (val) {
                this.active = val
            },

            active (val) {
                if(val) {
                    if(Object.keys(this.data).length) {
                        this.convertOptionsDataToArray()
                    } else {
                        this.clearForm()
                    }
                } else
                    this.clearForm()

                this.$emit('close', val)
            },

            optionsData : {
                handler (newValue) {
                    newValue = this.rearangeItemSortOrder(newValue.items)
                },
                deep : true
            }
        },

        methods : {
            convertOptionsDataToArray () {
                let items = Object.entries(this.data.items)
                let newItems = []

                items.forEach(item => {
                    newItems.push({
                        id: item[0],
                        ...item[1]
                    })
                })

                newItems = this.setItemSortOrderIfNotExists(newItems)
                this.optionsData = {...this.data, items : newItems.sort((a,b) => a.order - b.order)}
            },

            setItemSortOrderIfNotExists(items) {
                for (let i = 0; i < items.length; i++) {
                    if(!items[i].hasOwnProperty('order'))
                        items[i].order = i
                }

                return items
            },

            rearangeItemSortOrder (items) {
                for (let i = 0; i < items.length; i++) {
                    items[i].order = i
                }

                return items
            },

            convertOptionsDataToObject() {
                let newItems = {}
                this.optionsData.items.forEach((item, i) => {
                    let obj = Object.assign({ order: i }, item)
                    newItems[item.id] = obj
                })

                delete this.optionsData.text
                delete this.optionsData.showItems
                delete this.optionsData.value

                if(this.optionsData.hasOwnProperty('max')) {
                    let max = this.optionsData.max
                    this.optionsData.type = max > 1 ? 'multiple' : 'single'
                }
            
                return {...this.optionsData, ...{items : newItems} }
            },

            async save () {
                try {
                    let validate = await this.validateFields()
                    if(validate) throw new Error(validate)

                    let newOptionObject = this.convertOptionsDataToObject()

                    this.loading = true
                    await ref.collection(`/company/${this.companyId}/productOptions`).doc(this.optionsData.id).set(newOptionObject)
                    let successPropagate = await propagate(this.companyId, this.optionsData.id, newOptionObject)
                    if(successPropagate) throw new Error(successPropagate)

                    this.$success({
                        zIndex: 9999999,
                        title: 'Sucesso!',
                        content: 'Produto salvo com sucesso!'
                    })

                    this.clearForm()
                    this.active = false
                    this.$emit('saved', newOptionObject)
                } catch (err) {
                    this.$error({
                        zIndex: 9999999,
                        title: 'Erro!',
                        content: `Erro ao tentar salvar: ${err.message}`
                    })
                } finally {
                    this.loading = false
                }
            },

            validateFields () {
                return new Promise (async resolve => {
                    let validate = await this.$refs['frm'].validate()
                    if(!validate) resolve('Preencha os campos corretamente.')
                    if(this.optionsData.hasOwnProperty('items'))
                        if(!this.optionsData.items.length) resolve('Adicione pelo menos um item à opção.')

                    resolve('')
                })         
            },

            async removeItemOption (itemId) {
                let items = [...this.optionsData.items]

                this.optionsData.items.forEach((item, i) => {
                    if(itemId == item.id)
                        this.$delete(this.optionsData.items, i)
                })
            },

            addMoreItemsOption () {
                this.optionsData.items.push({
                    id : _misc.generateId(21),
                    description : '',
                    max : 1,
                    min : 0,
                    value : 0,
                    order : this.getLastSortOrder(),
                    active : true
                })
                this.optionsData.items = this.optionsData.items.sort((a,b) => a.order - b.order)
            },

            getLastSortOrder () {
                const last = this.optionsData.items.sort((a, b) => b.order - a.order)
                return !last.length ? 0 : last[0].order + 1
            },

            clearForm () {
                this.optionsData = {
                    id: _misc.generateId(21),
                    alias : '',
                    description : '',
                    max : 1,
                    min : 0,
                    items : [],
                    order : 1
                }
            },
        }
    }
</script>

<style scoped>
    .btn-remove-product-option {
        position: absolute;

        top: -15px; 
        left: 97%;
    }

    .ckb-item-enabled {
        position: absolute;

        top: -8px; 
        right: 96%;
    }

</style>